import { render, staticRenderFns } from "./ion-form.vue?vue&type=template&id=55c70bf3"
import script from "./ion-form.vue?vue&type=script&lang=js"
export * from "./ion-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports